class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11 11v3H3V2h5V1H3a.999.999 0 0 0-1 1v12a.997.997 0 0 0 1 1h8a1 1 0 0 0 .706-.294A1 1 0 0 0 12 14v-3h-1Z"></path><path d="M14.769 2.88 13.12 1.229a.798.798 0 0 0-1.12 0l-7 7V11h2.763l7-7a.796.796 0 0 0 .228-.56.786.786 0 0 0-.228-.56h.006ZM7.349 10H6V8.649l4.72-4.726 1.354 1.357L7.35 10Zm5.431-5.426L11.423 3.22l1.137-1.137 1.354 1.357-1.134 1.134Z"></path></svg>';
  }
}
const t = "pi-mod-custom-lists";
customElements.get(t) || customElements.define(t, s);
export {
  s as default
};
